import { fromSlug } from '@/lib/utils'

const SIGNUP_VALUE_CENTS = 500

// EA-821: a signup that originates from a deal flow is worth less than a
// standalone signup — the deal claim is already tracked with its own value, so
// counting the account-creation event at full value double-counts the conversion.
export const DEAL_SIGNUP_VALUE_CENTS = 100

type AffiliateInfo = {
  name: string
  epcValue?: number | null
}

type FathomEventOptions = {
  _value?: number
}

// URL → affiliate info mapping, populated by processAffiliateLink at render time
const affiliateInfoMap = new Map<string, AffiliateInfo>()

export function registerAffiliateInfo(url: string, info: AffiliateInfo) {
  affiliateInfoMap.set(url, info)
}

function fathomTrackEvent(name: string, opts?: FathomEventOptions) {
  if (typeof window !== 'undefined' && window.fathom) {
    window.fathom.trackEvent(name, opts)
  }
}

export function trackFormSubscribe() {
  fathomTrackEvent('Form: Subscribe', { _value: SIGNUP_VALUE_CENTS })
}

export function trackFormSignup(valueCents: number = SIGNUP_VALUE_CENTS) {
  fathomTrackEvent('Form: Signup', { _value: valueCents })
}

export function trackFormDealClaim(appName?: string, claimValueCents?: number) {
  fathomTrackEvent(`Deal: ${appName ?? 'Unknown'}`, { _value: claimValueCents ?? 0 })
}

export function trackAffiliateLinkClick(url: string) {
  const slug = url.match(/efficient\.link\/r\/([^/?#]+)/)?.[1] ?? url
  const info = affiliateInfoMap.get(url)
  const name = info?.name ?? fromSlug(slug)
  const opts =
    info?.epcValue !== null && info?.epcValue !== undefined ? { _value: info.epcValue } : undefined
  fathomTrackEvent(`Affiliate: ${name}`, opts)
}

export enum FeaturedPlacement {
  HOME_PILLS = 'Home Pills',
  HOME_REVIEW_CARDS = 'Home Review Cards',
  HOME_DEALS = 'Home Deals',
  NAV_DISCOVER = 'Nav Discover',
  NAV_DEALS = 'Nav Deals',
  COMPARE_NAV = 'Compare Nav',
  SIDEBAR_DEALS = 'Sidebar Deals',
  BEST_MIDPAGE = 'Best Midpage',
  REVIEW_HERO = 'Review Hero',
  REVIEW_FEED = 'Review Feed',
  ALTERNATIVES = 'Alternatives',
  TRENDING = 'Trending',
  DEALS_HERO = 'Deals Hero',
  DEALS_FEED = 'Deals Feed',
}

export function trackFeaturedClick(placement: FeaturedPlacement, appName: string) {
  fathomTrackEvent(`Featured: ${placement} - ${appName}`)
}
